import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { COMPANY, SUPPORT_EMAIL } from '../data/launch';
export function Disclaimer() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-510" data-mp="1awkv5bfv4kbo">
      <SEO title="Disclaimer | KittyPot" description="What KittyPot does and does not do. KittyPot helps groups record and split shared expenses; it does not hold or move customer money." ogTitle="KittyPot Disclaimer" ogDescription="What KittyPot does and does not do." path="/disclaimer" data-id="element-511" data-mp="e50k9575oyko" />
      <Navbar data-id="element-512" data-mp="3rmjc70smgpqc" />
      <main className="pt-32 pb-24" data-id="element-513" data-mp="3rkyhnb6b56sh">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-514" data-mp="3rjx5f3dk2e96">
          <h1 className="text-4xl font-black text-kitty-dark mb-4" data-id="element-515" data-mp="3vmjrennjp4yg">
            Disclaimer
          </h1>
          <p className="text-gray-500 font-medium mb-10" data-id="element-516" data-mp="20m3lbblvui4y">
            Last updated: 26 August 2026
          </p>

          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-517" data-mp="1vp3olraxarqi">
            <p data-id="element-518" data-mp="1qwajv3fgfjef">
              This disclaimer should be read alongside our{' '}
              <Link to="/terms" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-519" data-mp="1lzabumz1o6ko">
                Terms of Use
              </Link>
              . It explains what KittyPot, provided by {COMPANY.legalName}, does
              and does not do.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-520" data-mp="180kgbbrvieyf">
              1. KittyPot is a record-keeping tool
            </h2>
            <p data-id="element-521" data-mp="32d0km713zj0n">
              KittyPot helps you record shared expenses, split them between the
              people involved and keep track of who owes what. It does not give
              financial, tax, legal or accounting advice.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-522" data-mp="vmf5jrs8qgjl">
              2. We do not hold or move money
            </h2>
            <p data-id="element-523" data-mp="lqu3jtn69g9u">
              KittyPot does not hold customer funds, does not act as a wallet
              and does not transfer money between members. Group members settle
              up directly with each other. Marking something as paid in KittyPot
              records that a payment was made elsewhere; it does not make the
              payment.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-524" data-mp="14gts8ff3otcq">
              3. Figures come from you
            </h2>
            <p data-id="element-525" data-mp="19f3lull6flw8">
              Balances, splits and settlement suggestions are calculated from
              the information members enter. Please check amounts, payers and
              splits before relying on them. If something has been entered
              incorrectly, the figures will be wrong. An expense cannot be
              edited after it is added, so a wrong entry needs to be deleted and
              added again.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-526" data-mp="27big47tejehe">
              4. Receipts and scanned details
            </h2>
            <p data-id="element-527" data-mp="2h729onkhu12z">
              Where KittyPot reads details from a receipt image, the reading
              happens on your own device and the result is a suggestion to save
              you typing. It may misread an amount or a date, so please check it
              before saving the expense.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-528" data-mp="22akx5t0kigeu">
              5. Currency conversions
            </h2>
            <p data-id="element-529" data-mp="1xi1nh75045fb">
              Converted amounts shown in KittyPot are estimates presented for
              convenience. They may differ from the rate your bank or payment
              provider applies when you actually settle.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-530" data-mp="1ihxqjtjwqhnf">
              6. Availability
            </h2>
            <p data-id="element-531" data-mp="1nfzbkk0w8r1j">
              We work to keep KittyPot running, but we cannot guarantee it will
              be available at all times. Maintenance, technical faults or
              third-party outages may interrupt the service.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-532" data-mp="1x8n6tac86my5">
              7. Third-party services
            </h2>
            <p data-id="element-533" data-mp="266yub3hsp4md">
              KittyPot relies on third-party services to operate, and our
              website may link to sites we do not control. We are not
              responsible for the content or availability of those third parties.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-534" data-mp="2g4mz6m947si9">
              8. Questions
            </h2>
            <p data-id="element-535" data-mp="gun9860ur9e2">
              If anything here is unclear, email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-536" data-mp="lrx3byz6s988">
                {SUPPORT_EMAIL}
              </a>
              . Our responsibility to you is set out in our{' '}
              <Link to="/terms" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-537" data-mp="4fymrn25xitn">
                Terms of Use
              </Link>
              , and nothing here affects your legal rights as a consumer.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-538" data-mp="n7rdfatrery7" />
    </div>;
}